import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Memo from './icon-memo.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Memo {...validProps} />;
}
SvgComponent.iconName = 'memo';

export const MemoIcon = svgIconWrapper(SvgComponent);
